import { setChatbotPollingIntervalId } from '../../actions/chatbot/actions';
import { TThunkAction } from '../../types/redux/thunk';

export const stopPollingMessages = (): TThunkAction<void> => (dispatch, getState) => {
  const {
    chatbot: { pollingIntervalId },
  } = getState();

  if (!pollingIntervalId) {
    return;
  }

  window.clearInterval(pollingIntervalId);
  dispatch(setChatbotPollingIntervalId(null));
};
